export enum IssueDetailTab {
  Comments = 'comments',
  Logs = 'logs',
  Tasks = 'tasks',
  FallbackLogsAndComments = 'logs_and_comments',
}
